/**
 * The custom icon library behind Geometry Configuration.
 *
 * GET /uploads/icons answers 500 whenever object storage is down, and the list
 * used to be read as data.files.map(...) — which threw "Cannot read properties
 * of undefined (reading 'map')" out of the store action and took the page with
 * it. A missing icon library is a failure of the library, not of the page: the
 * built-in icons stay usable and the picker says so.
 *
 * Pure module — no Vue, no store, no fetch of its own — so the parsing is
 * tested. See __tests__/iconLibrary.test.js.
 */

export const CUSTOM_ICONS_UNAVAILABLE = 'Custom icons could not be loaded';

/**
 * Read a response body that may not be JSON at all (a 500 from the gateway is
 * usually HTML). Never throws.
 */
export async function readJsonSafely(response) {
    if (!response || typeof response.json !== 'function') return null;
    try {
        return await response.json();
    } catch (error) {
        return null;
    }
}

/**
 * Turn a /uploads/icons response into the picker's list.
 * @returns { status, icons, message } — status false when the library could not
 *          be read, with icons [] and the message the picker renders.
 */
export function toCustomIconList(response, body) {
    if (!response || response.ok === false) {
        return { status: false, icons: [], message: CUSTOM_ICONS_UNAVAILABLE };
    }
    const files = body && body.files;
    if (!Array.isArray(files)) {
        return { status: false, icons: [], message: CUSTOM_ICONS_UNAVAILABLE };
    }
    const icons = files.map((filePath, index) => ({
        id: index + 1,
        url: filePath,
    }));
    return { status: true, icons, message: null };
}
